import { TrophyOutlined } from "@ant-design/icons";
import { Card, Empty, Progress, Skeleton, Tag, Typography } from "antd";
import type { BrigadeRating } from "@/app/api/types";
import {
	BRIGADE_RATING_COLORS,
	BRIGADE_RATING_LABELS,
	brigadeRatingStatus,
} from "@/shared/utils/brigadeRating";

const { Title, Text } = Typography;

interface TopBrigadesCardProps {
	brigades?: BrigadeRating[];
	loading?: boolean;
}

export function TopBrigadesCard({ brigades, loading }: TopBrigadesCardProps) {
	const rows = brigades ?? [];

	return (
		<Card loading={loading} className="shadow-card pt-2">
			<div className="flex items-center gap-2 mb-4">
				<TrophyOutlined className="text-warning text-xl" />
				<Title level={4} style={{ margin: 0 }}>
					Top brigadalar
				</Title>
			</div>
			{!loading && rows.length === 0 && (
				<Empty description="Brigadalar topilmadi" image={Empty.PRESENTED_IMAGE_SIMPLE} />
			)}
			{!loading && rows.length > 0 && (
				<div className="space-y-3">
					{rows.map((brigade, index) => {
						const status = brigadeRatingStatus(brigade);
						return (
							<div key={brigade.brigadeId} className="flex items-center gap-3">
								<span className="w-6 text-center text-ink-soft font-mono">{index + 1}</span>
								<div className="flex-1 min-w-0">
									<div className="flex items-center justify-between gap-2">
										<Text strong className="truncate">
											{brigade.brigadeName}
										</Text>
										<Tag color={BRIGADE_RATING_COLORS[status]} className="shrink-0">
											{BRIGADE_RATING_LABELS[status]}
										</Tag>
									</div>
									<Progress
										percent={Math.round(brigade.completionRate)}
										size="small"
										strokeColor={BRIGADE_RATING_COLORS[status]}
									/>
									<Text type="secondary" className="text-xs">
										{brigade.completedTasks}/{brigade.totalTasks} topshiriq bajarilgan
										{brigade.overdueIncompleteCount > 0 &&
											` · ${brigade.overdueIncompleteCount} muddati o'tgan`}
									</Text>
								</div>
							</div>
						);
					})}
				</div>
			)}
			{loading && <Skeleton active paragraph={{ rows: 4 }} />}
		</Card>
	);
}
